// 軽量 SVG アイコン（絵文字を置換）。currentColor 継承・stroke ベース（Lucide 風）。
// 大きさは size（既定18）。装飾目的なので aria-hidden。
type P = { size?: number };
const base = (size: number) => ({
  width: size, height: size, viewBox: "0 0 24 24",
  fill: "none", stroke: "currentColor", "stroke-width": 2,
  "stroke-linecap": "round" as const, "stroke-linejoin": "round" as const,
  "aria-hidden": true,
});

export const IconMoon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" /></svg>
);
export const IconSun = ({ size = 18 }: P) => (
  <svg {...base(size)}><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></svg>
);
export const IconPlus = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M12 5v14M5 12h14" /></svg>
);
export const IconArrowLeft = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
);
export const IconTrash = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6M10 11v6M14 11v6" /></svg>
);
export const IconCloudUp = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M12 13v8M8 17l4-4 4 4" /><path d="M20 16.6A5 5 0 0 0 18 7h-1.3A8 8 0 1 0 4 15" /></svg>
);
export const IconWifiOff = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M1 1l22 22M16.7 11.7A6 6 0 0 1 19 13M5 13a10 10 0 0 1 5.2-2.8M10.7 5.1A16 16 0 0 1 22.6 9M1.4 9a16 16 0 0 1 3.6-2.6M8.5 16.5a5 5 0 0 1 7 0M12 20h.01" /></svg>
);
export const IconAlert = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" /><path d="M12 9v4M12 17h.01" /></svg>
);
export const IconRefresh = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M21 12a9 9 0 1 1-2.6-6.4M21 4v5h-5" /></svg>
);
export const IconExternal = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M15 3h6v6M10 14 21 3M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /></svg>
);
export const IconInbox = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M22 12h-6l-2 3h-4l-2-3H2" /><path d="M5.5 5.1 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.5-6.9A2 2 0 0 0 16.8 4H7.2a2 2 0 0 0-1.7 1.1Z" /></svg>
);
export const IconX = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M6 6l12 12M18 6L6 18" /></svg>
);
export const IconLayout = ({ size = 18 }: P) => (
  <svg {...base(size)}><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M9 21V9" /></svg>
);
export const IconPalette = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M12 2a10 10 0 1 0 0 20c1.1 0 2-.9 2-2 0-.5-.2-1-.5-1.3-.3-.4-.5-.8-.5-1.2 0-1 .8-1.8 1.8-1.8H16a6 6 0 0 0 6-6c0-5-4.5-8-10-8Z" /><circle cx="7.5" cy="10.5" r="1.2" fill="currentColor" stroke="none" /><circle cx="12" cy="7.5" r="1.2" fill="currentColor" stroke="none" /><circle cx="16.5" cy="10.5" r="1.2" fill="currentColor" stroke="none" /></svg>
);
